import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import Header from '../../components/customer/Header';
import Footer from '../../components/customer/Footer';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [creating, setCreating] = useState(true);
  const [orderId, setOrderId] = useState(null);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    createOrderFromPayment();
  }, []);
  
  const createOrderFromPayment = async () => {
    try {
      console.log('📦 Creating order from payment success...');
      
      // Get order data from localStorage
      const orderDataStr = localStorage.getItem('pending_order');
      const bogOrderId = localStorage.getItem('bog_order_id');
      
      if (!orderDataStr) {
        console.log('⚠️ No pending order found');
        setError('No order data found');
        setCreating(false);
        return;
      }
      
      const orderData = JSON.parse(orderDataStr);
      console.log('✅ Found pending order:', orderData.customer_name);
      
      // Create order in database
      const response = await api.post('/orders/create-from-payment', {
        bog_order_id: bogOrderId,
        order_data: orderData
      });
      
      if (response.data.success) {
        console.log('✅ Order created:', response.data.order_id);
        setOrderId(response.data.order_id);
        
        // Clean up localStorage
        localStorage.removeItem('pending_order');
        localStorage.removeItem('bog_order_id');
      } else {
        throw new Error('Failed to create order');
      }
      
    } catch (err) {
      console.error('❌ Error creating order:', err);
      setError('Failed to create order. Please contact support.');
    } finally {
      setCreating(false);
    }
  };
  
  if (creating) {
    return (
      <>
        <Header />
        <div style={{ 
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '2rem'
        }}>
          <div>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⏳</div>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
              Creating your order...
            </h2>
            <p style={{ color: '#666' }}>Please wait a moment</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  if (error) {
    return (
      <>
        <Header />
        <div style={{ 
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '2rem'
        }}>
          <div>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>❌</div>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '0.5rem', color: '#dc3545' }}>
              Error
            </h2>
            <p style={{ color: '#666', marginBottom: '2rem' }}>{error}</p>
            <button 
              onClick={() => navigate('/')}
              style={{
                padding: '0.75rem 2rem',
                background: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              Go to Homepage
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  return (
    <>
      <Header />
      <div style={{ 
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem'
      }}>
        <div style={{
          maxWidth: '500px',
          background: 'white',
          padding: '3rem',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}>
          <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>✅</div>
          <h1 style={{ 
            fontSize: '2rem', 
            marginBottom: '1rem',
            color: '#28a745'
          }}>
            Payment Successful!
          </h1>
          <div style={{
            background: '#f8f9fa',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '2rem'
          }}>
            <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
              Order Number
            </p>
            <h2 style={{ fontSize: '1.8rem', color: '#007bff', margin: 0 }}>
              #{orderId}
            </h2>
          </div>
          <p style={{ color: '#666', marginBottom: '2rem' }}>
            Thank you for your purchase! Your order has been confirmed and will be processed shortly.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
            <button 
              onClick={() => navigate('/my-orders')}
              style={{
                padding: '0.75rem 2rem',
                background: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: '500'
              }}
            >
              View My Orders
            </button>
            <button 
              onClick={() => navigate('/')}
              style={{
                padding: '0.75rem 2rem',
                background: 'white',
                color: '#007bff',
                border: '2px solid #007bff',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: '500'
              }}
            >
              Continue Shopping
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentSuccess;